import * as types from '../actionTypes';
import { getCommentCountBySkuId, getComparedInfo, handleProductSearch, productFollow, productIsFollow, queryAdvertisement, queryRecommends, queryShopChat, queryPrdPrice } from '../../api';

export const dispatchSearchProduct = (value) => {
  const params = {
    functionId: 'jdwProductSearch',
    appid: 'jdw_pc',
    client: 'pc',
    body: value
  }
  const config = { isSigned: true }
  return async (dispatch) => {
    let data = {}
    try {
      const res = await handleProductSearch(params, config);
      if (res.code == 0) {
        data = res.result
      }
    } catch (error) {

    } finally {
      dispatch(dispatchSearchLoading(false))
      dispatch({
        type: types.SEARCH_PRODUCTS,
        value: {
          // params: params,
          data
        }
      })
    }
  }
}

export const dispatchCrumb = (value) => {
  return async dispatch => {
    dispatch({
      type: types.CHANGE_CRUMB,
      value
    })
  }
}

export const dispatchUrlParams = (value) => {
  return dispatch => {
    dispatch({
      type: types.URL_PARAMS,
      value
    })
  }
}

export const dispatchQueryAdvertisement = (params) => {
  return dispatch => {
    const querys = params.map(item => queryAdvertisement({ skuids: item.toString() }))
    Promise.all(querys).then(res => {
      dispatch({
        type: types.ADVERTISEMENTS,
        value: [].concat(...res)
      })
    })

  }
}

export const dispatchQueryPrdPrice = (params) => {
  return dispatch => {
    const config = { isSigned: true }
    const querys = params.map(item => queryPrdPrice({
      functionId: 'mzhprice_getCustomRealPriceInfoForColor',
      appid: 'jdw_pc',
      body: { "skuPriceInfoRequestList": item }
    }, config))
    Promise.all(querys).then(res => {
      const prices = {}
      res.forEach(data => {
        if (data.success && data.skuPriceInfoResponseList) {
          data.skuPriceInfoResponseList.forEach((item) => {
            prices[item.skuId] = item.priceResult
          })
        }
      })
      
      dispatch({
        type: types.PRODUCTSPRICE,
        value: prices
      })
    })
  }
}

export const dispatchQueryShopChat = (params) => {
  return async dispatch => {
    const res = await queryShopChat(params);
    dispatch({
      type: types.SHOPCHAT,
      value: res
    })
  }
}

export const dispatchGetCommentCountBySkuId = (params) => {
  return async (dispatch) => {
    const res = await getCommentCountBySkuId(params);
    if (res.code == 0) {
      dispatch({
        type: types.COMMENTS,
        value: JSON.parse(res.result)
      })
    }
  }
}

export const dispatchSubCompareList = (value) => {
  return dispatch => {
    dispatch({
      type: types.SUB_COMPARELIST,
      value
    })
  }
}

export const dispatchAddCompareList = (params) => {
  return async dispatch => {
    const res = await getComparedInfo(params);
    dispatch({
      type: types.ADD_COMPARELIST,
      value: res[params.ids]
    })
  }
}

export const dispatchModalShow = (value) => {
  return dispatch => {
    dispatch({
      type: types.MODAL_VISIBLITY,
      value
    })
  }
}

export const dispatchTipStatus = (value) => {
  return dispatch => {
    dispatch({
      type: types.TIP_STATUS,
      value
    })
  }
}

export const dispatchMulFilter = (value) => {
  return (dispatch) => {
    dispatch({
      type: types.MULFILTER,
      value
    })
  }
}

export const dispatchMulBtnIdx = (value) => {
  return (dispatch) => {
    dispatch({
      type: types.MULBTNIDX,
      value
    })
  }
}

export const dispatchMoreBtnIdxs = (value) => {
  return (dispatch) => {
    dispatch({
      type: types.MOREBTNIDXS,
      value
    })
  }
}

export const dispatchRecommend = (value) => {
  const params = {
    functionId: 'recDivinerApi',
    appid: 'jdw_pc',
    client: 'pc',
    body: value
  }
  const config = { isSigned: true }
  return async dispatch => {
    const res = await queryRecommends(params, config);
    // const skuids = [res.data.map((item) => ({ skuId: item.sku }))]
    // dispatchQueryPrdPrice(skuids)(dispatch);
    dispatch({
      type: types.RECOMMENDS,
      value: res.data
    })
  }
}


export const dispatchProductsFollowStatus = (value) => {
  const params = {
    functionId: 'productIsFollow',
    appid: 'jdw_pc',
    client: 'pc',
    body: value
  }
  return async dispatch => {
    const res = await productIsFollow(params)
    if (res.code === '3') {
      dispatch({
        type: types.LOGIN_STATUS,
        value: false
      })
    } else if (res.code === '0') {
      dispatch({
        type: types.PRODUCTS_FOLLOW_STATUS,
        value: JSON.parse(res?.result || '{}')?.data || {}
      })
    }
  }
}


export const dispatchFollowProduct = (value) => {
  const params = {
    functionId: 'productFollow',
    appid: 'jdw_pc',
    client: 'pc',
    body: value
  }

  return async dispatch => {
    const res = await productFollow(params)
    if (res.code === '0') {
      dispatch({
        type: types.FOLLOW_PRODUCT,
        value: {
          skuId: value,
          status: JSON.parse(res?.result)?.success
        }
      })
    }
  }
}

export const dispatchSearchLoading = (value) => {
  return dispatch => {
    dispatch({
      type: types.SEARCH_LOADING,
      value
    })
  }
}